module.exports = __webpack_public_path__ + "img/artboard16.d9cf3740.png";